import { isNullOrUndefined } from '@beef/utils';
import { POPUP_TYPES } from "../../../../store/blocks/infoCards/constants";
import { getCurrentPopupStep } from "../../../../store/blocks/infoCards/selectors";
import { setPopupStep } from "../../../../store/infoCards/actions";
import { SupportInfoItemType } from "../SupportInfoListItem/utils";
export var handleChangePopupStep = function handleChangePopupStep() {
  return function (dispatch, getState) {
    var state = getState();
    var currentPopup = getCurrentPopupStep(state);
    if (currentPopup === POPUP_TYPES.supportInfoList) {
      dispatch(setPopupStep(POPUP_TYPES.appDownload));
    } else {
      dispatch(setPopupStep(POPUP_TYPES.supportInfoList));
    }
  };
};

/* Пока нет основного чата, используем pop-up "Электронный помощник", который не отображается на мобилках
 * удаляем пункт с чатом на мобилках */
export var excludeChat = function excludeChat(card, isMobile) {
  var isChat = card.type === SupportInfoItemType.chat;
  return !(isChat && isNullOrUndefined(card.href) && isMobile);
};